import { analyticsConfig } from '../data/site'

type EventParams = Record<string, string | number | boolean>

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

// Analytics only runs on the live site. Editor previews, other hostnames, and
// localhost never load the tag or send events.
const ALLOWED_HOSTNAMES = ['cvthomas.com', 'www.cvthomas.com']

export function isAnalyticsEnabled() {
  if (typeof window === 'undefined') return false
  return (
    Boolean(analyticsConfig.measurementId) &&
    ALLOWED_HOSTNAMES.includes(window.location.hostname.toLowerCase())
  )
}

let initialized = false

/**
 * Loads Google Analytics 4 once per page load. Page views, scroll depth, and
 * outbound clicks are collected automatically by GA4 Enhanced Measurement;
 * the custom events below add detail about what visitors interact with.
 */
export function initAnalytics() {
  if (initialized || !isAnalyticsEnabled()) return
  initialized = true

  const id = analyticsConfig.measurementId
  const src = `https://www.googletagmanager.com/gtag/js?id=${id}`

  // Guard against a tag that was already added (e.g. by hot reload or a second mount)
  if (!document.querySelector(`script[src="${src}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = src
    document.head.appendChild(script)
  }

  if (!window.gtag) {
    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      // gtag expects the raw arguments object, not an array
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', id)
  }
}

export function trackEvent(name: string, params: EventParams = {}) {
  if (!isAnalyticsEnabled() || !window.gtag) return
  window.gtag('event', name, params)
}

export type BookingLocation = 'header' | 'hero' | 'coaching' | 'closing'

export function trackBookingClick(location: BookingLocation) {
  trackEvent('book_intro_click', { button_location: location })
}
